export default "__VITE_ASSET__C68_ApmA__"